<form
	(ngSubmit)="onFormSubmit()"
	[formGroup]="form"
	cdkTrapFocus>
	<div class="modal-content" goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="task-details_add_instructions" [id]="dialogTitleId"></h4>
			<button
				class="close-btn"
				type="button"
				aria-label="{{'common_close' | translate}}"
				(click)="dismiss()">
				<i class="ficon-app-x"></i>
			</button>
		</div>

		<div class="goreact-modal-body flex-column">
			<div class="instructions-container">
				<div class="label-container">
					<label
						class="goreact-label text-instructions-heading"
						for="text-instructions-input"
						translate="activity-instructions-editor-modal_text-instructions-heading">
					</label>
				</div>

				<ngx-rich-text-editor
					#instructionsEditor
					[content]="editedData.text"
					[ariaLabel]="'activity-instructions-editor-modal-enter-instructions-here' | translate"
					placeholder="{{ 'activity-instructions-editor-modal-enter-instructions-here' | translate }}"
					(updateEvent)="updateText($event)"
				></ngx-rich-text-editor>

				<!-- Error message -->
				@if (instructionText().length > CHARACTER_LIMIT) {
					<p
						id="instructions-error-label"
						class="error-text"
						role="alert"
						translate="activity-instructions-editor_form-validation-error-content-length"
						[translateParams]="{
							characterLimit: CHARACTER_LIMIT,
							charactersOverLimit: instructionText().length - CHARACTER_LIMIT
						}">
					</p>
				}

				@if (editedData.media) {
					<div class="media-instructions-container">
						<ngx-panel>
							<panel-heading>
								<label
									class="goreact-label media-instructions-heading"
									translate="activity-editor-instructions_video-instructions">
								</label>
								<div class="actions">
									<i class="ficon-app-edit" (click)="openMediaPreviewModal(true)"></i>
									<i class="ficon-app-x" (click)="openRemoveMediaInstructionsModal()"></i>
								</div>
							</panel-heading>
							<panel-body>
								<ngx-media-thumbnail
									[media]="editedData.media">
								</ngx-media-thumbnail>
								<span
									(click)="openMediaPreviewModal(false)"
									class="title">{{ editedData.media.title }}
								</span>
							</panel-body>
						</ngx-panel>
					</div>
				}
			</div>
		</div>
		<div class="goreact-modal-footer" data-cy="instructions-modal-footer">
			<div class="left-group-buttons">
				@if (!editedData.media) {
					<button
						type="button"
						class="link-btn add-btn library-btn"
						[attr.aria-label]="'task-details_add_video_instructions_aria_label' | translate"
						data-cy="add-video-instructions"
						(click)="openLibrary()">
						<span translate="activity-editor-instructions_video-instructions"></span>
					</button>
				}

			</div>
			<div class="right-group-buttons">
				@if (form?.pristine) {
					<button
						type="button"
						class="goreact-btn primary-btn footer-close-btn"
						[attr.aria-label]="'common_close' | translate"
						translate="common_close"
						(click)="dismiss()">
					</button>
				} @else {
					<button
						type="button"
						(click)="dismiss()"
						translate="common_cancel"
						class="goreact-btn tertiary-btn cancel-btn">
					</button>
					<button
						type="submit"
						class="goreact-btn primary-btn save-btn"
						[attr.aria-label]="'common_save' | translate"
						translate="common_save">
					</button>
				}
			</div>
		</div>
	</div>
</form>
